<template>
    <b-tab :title="$store.state.localization.data.mainPage.clients.tabs.main" active>
        <b-form-group>
          <b-form-checkbox v-model="isActive">
                {{
                  $store.state.localization.data.mainPage.users.userInfo.state
                }}
              </b-form-checkbox>
        </b-form-group>
        
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.userNameLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="userName"
            :state="isUserNameValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.emailLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="email"
            :state="isEmailValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.passwordLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="password"
            :state="isPasswordValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
      </b-tab>
  </template>
  
  <script>
  
  export default {
    name: "MainTab",
    props: {
      user: Object
    },
    data() {
      return {
        isActive: false,
        userName: null,
        email: null,
        password: null,
        isUserNameValid: null,
        isEmailValid: null,
        isPasswordValid: null,
      };
    },
    methods: {
      validate() {
        let isValid = true;

        if (!this.userName) {
          this.isUserNameValid = false;
          isValid = false;
        } else {
          this.isUserNameValid = null;
        }
  
        if (!this.email) {
          this.isEmailValid = false;
          isValid = false;
        } else {
          this.isEmailValid = null;
        }
  
        if (!this.password) {
          this.isPasswordValid = false;
          isValid = false;
        } else {
          this.isPasswordValid = null;
        }
  
        return isValid;
      },
      getMainData() {
        return {
            isActive: this.isActive,
            email: this.email,
            userName: this.userName,
            password: this.password
        };
      }
    },
  };
  </script>
  